import { AppService } from './crud/app'
import { BillService } from './crud/bill'
import { LicenseService } from './crud/license'
import { SuperAdminService } from './admin'

class Api {
    constructor(){

    }
    superAdmin = new SuperAdminService()
    app = new AppService()
    bill = new BillService()
    license = new LicenseService()
}
const api = new Api

export default api



// WEBPACK FOOTER //
// ./src/services/index.js